import axios from "axios";

const cmsApi = axios.create({
  baseURL: `${import.meta.env.VITE_PARKIZA_CMS_URL}/api`,
});

export default cmsApi;
